import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function NewTen() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <div className="">
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>newTen</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                        newTen is an interactive artifact that alters the way you consume news by giving users control over the news they consume.
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/romeroseb/" target="_blank" rel="noopener noreferrer">Sebastian (Hunkeler) Romero</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/leonardo-amico/" target="_blank" rel="noopener noreferrer"> Leonardo Amico</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="nitinsurendran.com" target="_blank" rel="noopener noreferrer">Nitin Surendran</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/nandita-nina-shenoy-537858117/" target="_blank" rel="noopener noreferrer"> Nina Shenoy</a>
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/omar-razo-a837291/" target="_blank" rel="noopener noreferrer"> Omar A. Razo</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-3.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-9.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                            
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Arduino</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>API</Tag>
                                    <Tag>CIID</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>
                    
                </div>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        <Row>
            <Col span={24}>
                <div className="videoHeight">
                    <iframe src="https://player.vimeo.com/video/430400514?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
            </Col>
        </Row>
        
        <Row className="m80-t">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">challenge</Text>
                            <Text><strong>Reinvent an ordinary object by adding a new, or reimagining its existing, interactivity that considers a beyond-the-user scale.</strong></Text>
                            <Text>
                                <br/>
                                As the world becomes increasingly complex and our actions are confronted by events that are beyond our direct control, it's no longer enough to design a product focussing only on its primary user.  The challenge is to break up the ordinary user centered scale of design and think outside the box to make experienceable the many hidden ramifications of the user-product relationship. 
                            </Text>
                            
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                                newTen gives you the agency to choose what geographical radius you want your news from and fetches the top 10 credible news headlines based on the distance you travel on the device (local to world wide).
                            </Text>
                            <Text>
                                <br/>
                            In today’s times, people are bombarded with news from multiple different media platforms. The team set out to find a way to give people news highlights from reliable sources without them having to scroll through endless pages of news that may or may not be verified.
                            </Text>
                        </Space>
                    </Col>
                </Row>

                <Row className="m120-t">
                    <Text className="projectTitle">Research Insights</Text>
                </Row>

                <Row className="m120-b" justify="space-between">
                    
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m24-t">
                            <Image src={require("../assets/projects/newten/newten_12.png")}/>
                            <div className="m16-t"><Text><strong>Control</strong></Text></div>
                            <div><Text>People would like to have control over the news they consume. This can be done by providing them with well authored, fact-checked, verified news.</Text></div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m24-t">
                            <Image src={require("../assets/projects/newten/newten_13.png")}/>
                            <div className="m16-t"><Text><strong>Affordance</strong></Text></div>
                            <div><Text>People appreciate having interactions with objects that they have some agency over</Text></div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m24-t">
                            <Image src={require("../assets/projects/newten/newten_14.png")}/>
                            <div className="m16-t"><Text><strong>Challenging biases</strong></Text></div>
                            <div><Text>In this age of the internet, information can be easily manipulated. Social media - where most people get their news these days is designed to confirm our biases and show us what we want to see.</Text></div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m24-t">
                            <Image src={require("../assets/projects/newten/newten_15.png")}/>
                            <div className="m16-t"><Text><strong>Advertisements</strong></Text></div>
                            <div><Text>With most traditional news organizations moving online, their main source of revenue now comes from advertisers, which means the competition for clicks is fierce and low quality news sources are everywhere. </Text></div>
                        </Col>
                    
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row className="whiteBG">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row  className="m80-t m24-b">
                    <Title className="whiteBGTitle">Prototype</Title>
                </Row>
                <Row justify="space-between">
                    <Col span={24}>
                            <Text className="whiteBGTitle ">
                            newTen is built using an Arduino Uno connected to P3 processing which scrapes data from a News API. This fact checked news is then outputted in the form of audio through the device. The location range indication on the device is built using a Neo-pixel of 64 LEDs connected in together to glow when a potentiometer mapped to the LED is turned.
                            </Text>
                    </Col>
                </Row>
                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_1.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Exploring how one can select what kind of news they want to listen to.
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_2.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    What if we could listen to news based on location relevance. More dots corresponds to the distance of news source from the listener.
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_3.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    More explorations on having control over geographical source of news
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_4.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Control Flow - Playing news through P3 processing via Arduino
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_5.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Setting distance defines news source location using NewsAPI. Placing a topic ring over it defines the news category.
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={"http://ciid.dk/root_ciidwww/wp-content/uploads/2020/06/10-1.gif"}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Potentiometer to control the radius of news source
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_9.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Nested neopixels to map distance
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_10.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Quick reduction of the circuit
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_8.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Exploring various materials for diffusion
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_6.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Potentiometer x Neopixel map
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row justify="space-between" className="m48-t m24-b">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_7.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Part Dissection
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11} className="m48-t">
                        <Image src={require("../assets/projects/newten/newten_11.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    3d print
                                </Text>
                            </div>
                    </Col>
                </Row>

                
                <Row justify="space-between" className="m48-t m80-b">
                    <Col xs={24} sm={24} md={24} lg={13} xl={13}>
                        <Row>
                            <Text className="whiteBGTitle">
                                newTen has modular news categories. Each category is on a replaceable disc. The listener can chose which disc they want to 'tune' into. Each disc has the top 10 news headlines from that particular category.
                            </Text>
                        </Row>
                        <Row justify="space-between m24-t">
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <Text className="whiteBGTitle">
                                    <ul>
                                        <li>Sports</li>
                                        <li>Gaming</li>
                                        <li>Education</li>
                                    </ul>
                                </Text>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <Text className="whiteBGTitle">
                                    <ul>
                                        <li>Sports</li>
                                        <li>Gaming</li>
                                        <li>Education</li>
                                    </ul>
                                </Text>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                                <Text className="whiteBGTitle">
                                    <ul>
                                        <li>Sports</li>
                                        <li>Gaming</li>
                                        <li>Education</li>
                                    </ul>
                                </Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                        <Image src={require("../assets/projects/newten/newten_16.png")}/>
                    </Col>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Space direction={'vertical'}>
                    <Text className="projectTitle">Dummy news article</Text>
                    <Text>
                    newTen MEDIA STATION: RADIO REDESIGNED! 
                    <br/><br/>Praised as one of the most innovative products of the year!
                    <br/><br/>With media bombarding us constantly to the point of detachment, at a time when we are aware of how much we consume media, it poses the question: Can less be more?
                    <br/><br/>NNNO’s new media station newTen declutters your daily news intake by providing the top 10 news headlines from highly credible sources, and allows you to adjust the radius from localized state news, to news in your country, to news happening internationally. This will help people be more connected with their communities, and at a worldly level, in healthy, non-exhaustive doses. It also minimizes the news highlights to 10, so that people spend less time on their devices, and spend more time actively enjoying life.
                    <br/><br/>Recently unveiled & presented at tech shows: CES, Viva Technology, Computer Taipei, & GamesCom, newTen media station made a huge impression on consumers and judges alike. With a wave of industry buzz that overshadowed products by established tech giants like Amazon, Google, and Apple, newTen gathered praises like "I can’t wait to own one of these,” “it looks at the way we SHOULD BE consuming media,” & “creates a beautiful balance of media consumption and technological ‘off-time’."
                    <br/><br/>Even though it’s one of the more expensive products in its category, newTen still feels like it’s in a category all its own. Coming in at a consumer price point of $150, newTen is every bit worth that! It has the build quality of products that are double its price, and an impressive hi-fidelity sound output that is both, crisp & clear. The texture of the product is very smooth to the touch, the lights are bright and easy to see, the magnets holding the cartridges feel very secure, and the base is very grippy, so you don't have to worry about it accidentally sliding off of the table.  
                    <br/><br/>As for the cartridges, they are rings that fit over the top of the device and act as the knob itself for tuning in to where you will get your media from. The device includes a basic Politics cartridge, but others can be purchased on different categories such as Sports, Science, Entertainment, Gaming, Weather, Education, and more on the way at $50 a piece.
                    <br/><br/>When asked about their product, the innovative startup NNNO just stated, “We wanted to make something that would not only address how much we are exhausted on a daily basis with tidal waves of non-credible media, but would also connect us more with our local communities, as well as the world at large, in a simplified and sophisticated way. We believe our product does just that!”
                    <br/><br/>As someone who is eagerly awaiting this product, after trying it out, I can wholeheartedly agree. Yes, it does just that!

                    </Text>
                </Space>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default NewTen;